export default {
  layout: "pc",
};
